export default {
  layout: "pc",
};
